<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-position="top"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_content') || '含量'"
            prop="content"
          >
            <el-input
              ref="contentInput"
              v-model="formData.content"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              @input="contentInput"
              @blur="contentBlur"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_componentPositionName') || '成分位置'"
          >
            <dict-select
              v-model="formData.componentPosition"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :body="{ dictType: 'componentPosition' }"
              clearable
              filterable
              style="width: 100%"
              size="small"
              :options="{ value: 'code', label: 'label' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import { request } from '@/api/service'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: { content: 0 },
      rules: {
        content: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value && 0 !== value) {
                return callback(
                  new Error(
                    this.$l('INDEX.tips_input_placeholder') || '请输入...'
                  )
                )
              }
              if (!value && 0 == value) {
                return callback(
                  new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
                )
              }
              callback()
            },
          },
        ],
      },
    }
  },
  methods: {
    contentInput(value) {
      value = value.replace(/[^\d.]/g, '')
      value = value.replace(/^\./g, '')
      value = value.replace(/\.{2,}/g, '.')
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      this.formData.content = value
    },
    contentBlur() {
      const { content } = this.formData
      const value = content ? parseFloat(content) : 0
      this.formData.content = value > 100 ? 100 : value
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.formData.componentPosition) {
        if (this.loadingOpen()) return
        const res = await request({
          url: '/master/masterBizDictionary/detail',
          method: 'POST',
          data: { keyID: this.formData.componentPosition },
        }).catch(() => null)
        this.loadingClose()
        const data = res.body
        this.formData.componentPositionCn = data.dictText
        this.formData.componentPositionEn = data.dictTextEn
      }
      this.$emit('confirm', this.formData)
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
